import styles from './Logbook.module.css';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { LogbookListItem } from '../../types/logbook';
import { LFC } from '../../types';
import PdfIcon from '../../assets/icons/pdf.svg?react';

export interface LogbookItemProps extends LogbookListItem {}

export const LogbookItem: LFC<LogbookItemProps> = ({ status, id, day }) => {
  const navigate = useNavigate();

  const defaultAction = () =>
    navigate(
      `/logbook/${status === 'SIGNED' ? 'download' : 'report'}/${id ? id : day}`
    );

  return (
    <div className={styles.item}>
      <div className={styles.day}>{day}</div>
      <div
        onClick={defaultAction}
        className={clsx(
          styles.badge,
          status === 'DRAFT' && styles.filling,
          status === 'SIGNED' && styles.signed
          // status === 'day-off' && styles.dayOff
        )}
      >
        {status === undefined && <FormattedMessage id="Logbook.NoReport" />}
        {status === 'DRAFT' && <FormattedMessage id="Logbook.Filling" />}
        {status === 'SIGNED' && <FormattedMessage id="Logbook.Signed" />}
        {/* {type === 'day-off' && <FormattedMessage id="Logbook.DayOff" />} */}
      </div>
      <PdfIcon
        onClick={() => navigate(`/logbook/download/${id ? id : day}`)}
        className={styles.pdf}
      />
    </div>
  );
};
